import { Extension } from '@tiptap/core';

export const FontSizeExtension = Extension.create({
  name: 'fontSize',

  addOptions() {
    return {
      // Марк и ноды, к которым добавляем поддержку font-size
      types: ['textStyle', 'paragraph', 'listItem'],
    }
  },

  addGlobalAttributes() {
    return [
      {
        // Встраиваем атрибут fontSize во все указанные типы (mark + nodes)
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: element => element.style.fontSize?.replace(/['"]+/g, ''),
            renderHTML: attrs => {
              if (!attrs.fontSize) return {}
              return { style: `font-size: ${attrs.fontSize}` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setFontSize: fontSize => ({ chain }) => {
        // Применяем и к инлайн‑тексту (mark), и к текущему блоку (paragraph/listItem)
        return chain()
          .setMark('textStyle', { fontSize })
          .updateAttributes('paragraph', { fontSize })
          .updateAttributes('listItem', { fontSize })
          .run()
      },
      unsetFontSize: () => ({ chain }) => {
        return chain()
          .setMark('textStyle', { fontSize: null })
          .updateAttributes('paragraph', { fontSize: null })
          .updateAttributes('listItem', { fontSize: null })
          .removeEmptyTextStyle()
          .run()
      },
    }
  },
})

export default FontSizeExtension;
